import { toast } from 'react-toastify'

import queryString from 'query-string'
import {
  UsuarioParaImpersonateDTO,
  UsuariosParaImpersonateDados
} from 'src/dto'
import { OpcoesPaginacao, RespostaPadraoDadosAPI, TipoOrdenacao } from 'src/tipos'

import { gatewayApi, getApiError } from '../instancias-api'

const urlBase = '/Auth/impersonar'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const notificarErro = (ex: any, mensagemPadrao: string) => {
  getApiError(ex)
    .then(mensagens => {
      toast(mensagens?.length ? mensagens.join('\n') : mensagemPadrao, {
        type: 'error'
      })
    })
    .catch(() => toast(mensagemPadrao, { type: 'error' }))
}

export const RequisitarUsuariosParaImpersonate = async (
  nome: string,
  email: string,
  pagina: number,
  quantidadeRegistros: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: UsuarioParaImpersonateDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  const ordem = chaveOrdenacao
    ? `${chaveOrdenacao}${
        tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
      }`
    : undefined

  const filtros = queryString.stringify({
    nome,
    email,
    quantidadeRegistros,
    pagina,
    ordem
  })

  const {
    data: {
      data: { itens, quantidade }
    }
  } = await gatewayApi.get<RespostaPadraoDadosAPI<UsuariosParaImpersonateDados>>(
    `${urlBase}/usuarios?${filtros}`
  )

  return {
    registros: itens,
    opcoesPaginacao: {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }
  }
}

export const IniciarImpersonate = async (
  usuarioId: string
): Promise<string> => {
  try {
    const {
      data: {
        data: { token }
      }
    } = await gatewayApi.post<RespostaPadraoDadosAPI<{ token: string }>>(
      `${urlBase}/${usuarioId}`
    )

    return token
  } catch (ex) {
    notificarErro(ex, 'Não foi possível iniciar a sessão de impersonate.')
    return null
  }
}

export const SairDoImpersonate = async (): Promise<string> => {
  try {
    const {
      data: {
        data: { token }
      }
    } = await gatewayApi.post<RespostaPadraoDadosAPI<{ token: string }>>(
      `${urlBase}/sair`
    )

    return token
  } catch (ex) {
    notificarErro(ex, 'Não foi possível encerrar a sessão de impersonate.')
    return null
  }
}
